import { render, staticRenderFns } from "./MenuAddItemsList.vue?vue&type=template&id=e2e5a950&lang=html&"
import script from "./MenuAddItemsList.vue?vue&type=script&lang=js&"
export * from "./MenuAddItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports